import React from "react";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";

export default function ExpedientesHomeBreadcrumb({ tab }) {
    const navigate = useNavigate();

    return (
        <Breadcrumbs aria-label="breadcrumb" style={{ marginBottom: 18 }}>
            <Link
                color="inherit"
                onClick={() => navigate("/")}  // << antes: "/dashboard"
                style={{
                    cursor: "pointer",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    color: "#fff",
                    textShadow: "0 1px 4px #2228"
                }}
            >
                <HomeIcon fontSize="small" style={{ marginRight: 4, color: "#fff" }} />
                Inicio
            </Link>

            <Typography
                color="text.primary"
                style={{
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    color: "#fff",
                    textShadow: "0 1px 4px #2228"
                }}
            >
                <FolderOpenIcon fontSize="small" style={{ marginRight: 6, color: "#fff" }} />
                Expedientes {tab === 0 ? "Judiciales" : "Administrativos"}
            </Typography>
        </Breadcrumbs>
    );
}
